import React from 'react'

import './about.css';

const About = () => {
  return (
    <>
    <section className="top-section about">
      <div className="overlay">
        <div className="column">
          <h1>About Us</h1>
        </div>
      </div>
    </section>
    <section className="about-section-2">
      <div className="column col-1">
        <img src="/images/about/about-us.jpg"/>
        <div className="experience-box">
          <h1>30+</h1>
          <p>Years of<br/>experience</p>
        </div>
      </div>
      <div className="column col-2">
        <h2>
          Meet our family<br/>
          business
        </h2>
        <p>
          We may not have it all together but together we have it all! We are a family owned and operated business that aims to create a better world. We are a family of problem solvers that love the challenge. We have strong values and practice those values in all aspects of our life, including business.
        </p>
      </div>
    </section>
    <section className="about-section-3">
      <div className="overlay">
        <div className="content-container">
          <div className="column">
            <img className="icon" src="/images/about/designs-icon.svg"/>
            <h3>
              669
            </h3>
            <p><strong>Designs Created</strong></p>
          </div>
          <div className="column">
            <img className="icon" src="/images/about/patents-icon.svg"/>
            <h3>
              105
            </h3>
            <p><strong>Name on Patents</strong></p>
          </div>
          <div className="column">
            <img className="icon" src="/images/about/clients-icon.svg"/>
            <h3>
              12
            </h3>
            <p><strong>Customers Contracted</strong></p>
          </div>
          <div className="column">
            <img className="icon" src="/images/about/certifications-icon.svg"/>
            <h3>
              15
            </h3>
            <p style={{textAlign:"center"}}><strong>Professional Certifications</strong></p>
          </div>
        </div>
      </div>
    </section>
    <section className="about-section-4">
      <div>
        <h2>Who We Are!</h2>
      </div>
    </section>
    <section className="about-section-5">
      <div className="card-container">
        <div className="card">
          <img className="icon" src="/images/about/brain-icon.svg"/>
          <h4>Problem Solvers</h4>
          <p>
            <strong>Problem-solving is at the core of what we do</strong>, ensuring our clients achieve efficiency, precision, and success
          </p>
        </div>
        <div className="card">
          <img className="icon" src="/images/about/book-icon.svg"/>
          <h4>Wide Knowledge Base</h4>
          <p>
            With expertise across multiple industries, we deliver <strong>innovative, precise, and efficient solutions</strong> tailored to meet any project's needs
          </p>
        </div>
        <div className="card">
          <img className="icon" src="/images/about/family-icon.svg"/>
          <h4>Family Owned</h4>
          <p>
            We take pride in being a <strong>family-owned business</strong>, built on trust, integrity, and a commitment to excellence
          </p>
        </div>
      </div>
    </section>
    {/* <section className="about-section-6">
      <div className="container">
        <div className="column text">
          <h5>EXPERTISE</h5>
          <h2>Certifications &<br/>
            Qualifications</h2>
          <p>
            Three generations of learning, consulting training, gaining skills and experience. We're a family business, and we treat you as family, too. We handle every request with the utmost care and professionalism.
          </p>
        </div>
        <div className="column images-container">
          <div className="image-container">
            <div className="image" style={{backgroundImage: 'url(/about/byu-logo.png)'}}></div>
          </div>
          <div className="image-container">
            <div className="image" style={{backgroundImage: 'url(/about/byu-logo.png)'}}></div>
          </div>
          <div className="image-container">
            <div className="image" style={{backgroundImage: 'url(/about/byu-logo.png)'}}></div>
          </div>
          <div className="image-container">
            <div className="image" style={{backgroundImage: 'url(/about/byu-logo.png)'}}></div>
          </div>
        </div>
      </div>
    </section> */}
    </>
  )
}

export default About